import React, { useEffect, useState } from 'react';
import { Html5Qrcode, Html5QrcodeScanner } from 'html5-qrcode';
import { useNavigate } from 'react-router-dom';

const ProfileScanQR = () => {
  const navigate = useNavigate();
  const [qrCodeData, setQrCodeData] = useState(null);
  const [error, setError] = useState(null);
  const [isCameraActive, setIsCameraActive] = useState(true); 
  const [scannedData, setScannedData] = useState('');
  const [isScannerRunning, setIsScannerRunning] = useState(false);

  useEffect(() => {
    const html5QrCode = new Html5Qrcode("qr-reader");

    if (isCameraActive) {
      const qrboxSize = window.innerWidth < 768 ? { width: 300, height: 300 } : { width: 250, height: 250 };

      const scanner = new Html5QrcodeScanner(
        "qr-reader", 
        { fps: 10, qrbox: qrboxSize }
      );

    const videoConstraints = {
      facingMode: { ideal: "environment" }, 
    };

    navigator.mediaDevices.enumerateDevices().then(devices => {
        devices.forEach(device => {
          if (device.kind === 'videoinput') {
            // console.log(`${device.label} id = ${device.deviceId}`);
          }
        });
      });

      scanner.render(
        (decodedText) => {
          setQrCodeData(decodedText);
          setScannedData(decodedText); 
          setError(null); 
        },
        (error) => {
          setError(`Camera Scan Error: ${error}`);
          console.error("Scan error:", error);
        }
      );

      return () => {
        if (isScannerRunning) {
          html5QrCode.stop().then(() => {
            html5QrCode.clear();
            setIsScannerRunning(false);
          }).catch((err) => {
            console.error("Error stopping the scanner:", err);
          });
        }
      };
    }
  }, [isCameraActive, isScannerRunning]);


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const html5QrCode = new Html5Qrcode("qr-reader-file");
      html5QrCode.scanFile(file, true)
        .then((decodedText) => {
          // console.log("decodedText: ",decodedText);
          setQrCodeData(decodedText);
          setScannedData(decodedText);
          setError(null); 
        })
        .catch((err) => {
          setError(`File Scan Error: ${err}`);
          setQrCodeData(null); 
        });
    }
  };

  const handleClose = () => {
    navigate(-1); 
  };

  return (
    <div className='min-h-[100vh] flex flex-col justify-center items-center bg-gray-700 p-4 rounded-lg'>
      <h2 className="mb-4 text-2xl font-semibold text-yellow-200">Scan Think5Whys Profile QR Code</h2>

      {isCameraActive && (
        <div>
          <div id="qr-reader" style={{ width: '100%' }} />
          {scannedData && <p className="mt-4 text-center text-white">{scannedData}</p>}
        </div>
      )}

      {!isCameraActive && (
        <div>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="mb-4"
          />
          <div id="qr-reader-file" style={{ display: 'none' }} />
        </div>
      )}

      {error && (
        <div className="mt-4 p-4 text-red-400 rounded-lg">
          <p>{error}</p>
        </div>
      )}

      <button
        className="mt-4 w-20 bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded-full transition duration-300"
        onClick={handleClose}
      >
        Close
      </button>
    </div>
  );
};

export default ProfileScanQR;
